import { render } from "./mobileFr3Duo.vue?vue&type=template&id=35ba6359&scoped=true"
import script from "./mobileFr3Duo.vue?vue&type=script&lang=js"
export * from "./mobileFr3Duo.vue?vue&type=script&lang=js"

import "./mobileFr3Duo.vue?vue&type=style&index=0&id=35ba6359&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ba6359"]])

export default __exports__